import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Stethoscope({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Stethoscope</title>
      <path
        d="M5 4.75C5.41421 4.75 5.75 4.41421 5.75 4C5.75 3.58579 5.41421 3.25 5 3.25V4.75ZM11 3.25C10.5858 3.25 10.25 3.58579 10.25 4C10.25 4.41421 10.5858 4.75 11 4.75V3.25ZM5 3.25H4V4.75H5V3.25ZM2.25 5V9H3.75V5H2.25ZM13.75 9V5H12.25V9H13.75ZM12 3.25H11V4.75H12V3.25ZM13.75 5C13.75 4.0335 12.9665 3.25 12 3.25V4.75C12.1381 4.75 12.25 4.86193 12.25 5H13.75ZM8 14.75C11.1756 14.75 13.75 12.1756 13.75 9H12.25C12.25 11.3472 10.3472 13.25 8 13.25V14.75ZM2.25 9C2.25 12.1756 4.82436 14.75 8 14.75V13.25C5.65279 13.25 3.75 11.3472 3.75 9H2.25ZM4 3.25C3.0335 3.25 2.25 4.0335 2.25 5H3.75C3.75 4.86193 3.86193 4.75 4 4.75V3.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M8.75 14C8.75 13.5858 8.41421 13.25 8 13.25C7.58579 13.25 7.25 13.5858 7.25 14H8.75ZM19.75 14C19.75 13.5858 19.4142 13.25 19 13.25C18.5858 13.25 18.25 13.5858 18.25 14H19.75ZM7.25 14V15.5H8.75V14H7.25ZM19.75 15.5V14H18.25V15.5H19.75ZM13.5 21.75C16.9518 21.75 19.75 18.9518 19.75 15.5H18.25C18.25 18.1234 16.1234 20.25 13.5 20.25V21.75ZM13.5 20.25C10.8766 20.25 8.75 18.1234 8.75 15.5H7.25C7.25 18.9518 10.0482 21.75 13.5 21.75V20.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M10 3V5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 3V5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="19"
        cy="12"
        r="2"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
